/* tslint:disable */
/* eslint-disable */

/**
 * Status of TunnelSection
 */
export enum TunnelStatusType {
  Draft = 'DRAFT',
  Base = 'BASE',
  Disturbed = 'DISTURBED',
  Gravel = 'GRAVEL',
  Theorycalc = 'THEORYCALC',
  Gravelcalc = 'GRAVELCALC'
}
